var portfolioHeader = {
	baseCurrency: "Moneda base",
	numberOfPositions: "Posiciones",
	portfolioValue: "Valor del portafolio en {currency}",
	todayChange: "Cambio de hoy",
	unrealizedPerformance: "Rendimiento no realizado",
	purchaseValue: "Valor de la compra",
	realizedProfits: "Utilidades obtenidas",
	totalValue: "Valor total",
	totalPerformance: "Rendimiento total",
	lastCalculationDateTime: "Último cálculo"
};
var es = {
	portfolioHeader: portfolioHeader
};

export { es as default, portfolioHeader };
